import request from 'meinian-package/src/utils/request'

export const apiCreateConversation = body =>
  request.post('/backend-api/clothing-ai/conversation/create', body)

export const apiSendMessage = (body, conversationId) =>
  request.post('/backend-api/clothing-ai/conversation/send-message', { ...body, conversationId })

export const apiGetTaskCostCount = body =>
  request.post('/backend-api/clothing-ai/user-generate-pic-task/get-task-cost-count', body)

export const apiFetchTemplates = templateType =>
  request.get('/backend-api/clothing-ai/template/chatting-template', { params: { templateType } })

export const apiFetchHistory = params =>
  request.get('/clothing-ai/conversation/list-with-top-message', { params })

export const apiFetchMessages = params =>
  request.get('/backend-api/clothing-ai/conversation/list-messages', { params })

export const apiSingleDownload = id =>
  request.blob(`/backend-api/clothing-ai/user-generate-works/single-download?id=${id}`, false)

export const apiDeleteConversation = conversationId =>
  request.post('/backend-api/clothing-ai/conversation/delete', { conversationId })

export const apiAddUploadPicLog = picUrl =>
  request.post('/backend-api/clothing-ai/user-upload-pic-log/add', { picUrl, picSource: '20' })

export const apiFetchRecentCollect = () =>
  request.post('/zhikuan/image-bus/inspiration/list-blog?start=0&pageSize=10', {
    queryType: 'all', rankStatus: 1, sortOrderStatus: 0, labelMatrix: [], start: 0, pageSize: 10,
  })

export const apiFetchRecentUsed = () =>
  request.get('/backend-api/clothing-ai/user-upload-pic-log/page', {
    params: { start: 0, pageSize: 10, excludePicSourceList: '10,11,part,15,AiRecommendComponentPic', picSourceList: '' },
  })

export const apiConversationGet = params =>
  request.get('/backend-api/clothing-ai/conversation/get', { params })

export const apiFetchMeinianPlatforms = () =>
  request.get('/zhikuan/platform/mn-list-zk-platform')

export const apiFetchMeinianAllCategory = params =>
  request.get('/zhikuan/common/list-all-category', { params })

export const apiFetchMeinianCollectUsers = params =>
  request.get('/zhikuan/ins/inspiration/user-selector', { params })

export const apiFetchMeinianInspirationTree = () =>
  request.post('/zhikuan/ins/inspiration/list-simple-inspiration-tree', {})

export const apiFetchMeinianCommonMenuItems = () =>
  request.get('/zhikuan/common/list-common-menu-item', { ignoreError: true })

export const apiFetchMeinianGallery = (body, params = {}) =>
  request.post(`/zhikuan/image-bus/inspiration/list-blog?start=${params.start ?? 0}&pageSize=${params.pageSize ?? 30}`, body)

export const apiUploadTmpImg = imageUrl => request.get('/zhikuan/search/upload-tmp-img', { params: { imageUrl } })
